export default __webpack_public_path__ + "static/media/Girdle of Quilled Darts.d0d5a9ca.jpg";